import { defaults } from "lodash";
import store from "store";
import { renderAsElement } from "./utils";

export class Toasts {
  defaults = {
    selector: "[data-toast]",
    type: "info",
    message: "",
    duration: 3500,
    dismissable: true,
    store: false,
    storageKey: "__toast",
    template: (toast) => {
      let close = toast.dismissable ? ['<div class="toast-dismiss" data-toast-dismiss>', '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 64 64"><path d="M32.202 27.36L58.62.944c1.226-1.225 3.212-1.225 4.437 0s1.225 3.21 0 4.437L36.64 31.8l26.417 26.418c1.225 1.225 1.225 3.212 0 4.437s-3.21 1.225-4.437 0l-26.418-26.42L5.784 62.653c-1.225 1.225-3.212 1.225-4.437 0s-1.225-3.212 0-4.437l26.418-26.418L1.347 5.38C.122 4.154.122 2.168 1.347.943s3.212-1.225 4.437 0L32.202 27.36z"/></svg>', "</div>"].join("") : "";

      return ['<div class="toast toast-' + toast.type + '" data-toast>', close, "<p>" + toast.message + "</p>", "</div>"].join("");
    },
  };

  constructor() {
    document.addEventListener("click", this.onClick.bind(this), false);
    let toast = store.get(this.defaults.storageKey) || false;
    if (toast) {
      this.create(toast);
      store.remove(this.defaults.storageKey);
    }
    console.log("Toasts initialised");
  }

  onClick(event) {
    // // Don't run if right-click or command/control + click
    if (event.button !== 0 || event.metaKey || event.ctrlKey) return;
    // Dismiss
    let dismiss = event.target.closest("[data-toast-dismiss]");
    if (!dismiss) return;
    // Toast
    let toast = event.target.closest("[data-toast]");
    if (!toast) return;

    event.preventDefault();
    this.dismiss(toast);
  }

  create(options) {
    let settings = defaults(options || {}, this.defaults);
    if (settings.store) {
      settings.store = false;
      store.set(this.defaults.storageKey, settings);
      return;
    }
    let toast = renderAsElement(settings.template, settings);
    document.body.appendChild(toast);
    if (settings.duration) {
      setTimeout(() => {
        this.dismiss(toast);
      }, settings.duration);
    }
  }

  dismiss(toast) {
    if (!toast) return;
    toast.remove();
  }

  dismissAll(options) {
    let settings = defaults(options || {}, this.defaults);
    let toasts = document.querySelectorAll(settings.selector);
    if (toasts.length) {
      toasts.forEach((toast) => {
        this.dismiss(toast);
      });
    }
  }
}
